export default __webpack_public_path__ + "static/media/personal-loan-chart-3.49440d1c.svg";